import React, { useEffect, useState } from "react";
import "../styles/AddBranch.css";
import { useNavigate } from "react-router-dom";
import BusinessHubHeader from "../components/BusinessHubHeader";
import BackArrow from "../icons/BusinessHub/BackArrow";
import RelatedBInput from "./RelatedBInput";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon";
import { useLocation } from "react-router-dom";

import { userService } from "../services/userService";
import companyController from "../controllers/companyController";
import { toast } from "react-toastify";
import Utils from "../utils/Utils";
import getUser from "../controllers/userController";
import userController from "../controllers/userController";

function AddBranch() {
  const { state } = useLocation();
  const selectedType = state?.selectedType;
  const jwt = userService.getUser();
  const active = state?.active;
  const navigate = useNavigate();
  const [childDTO, setChildDTO] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [termsPop, setTermsPop] = useState(false);
  const [ischecked, setIschecked] = useState(false);
  useEffect(() => {
    if (termsPop) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [termsPop]);
  const handleSubmit = async () => {
    const parsed = Utils.parseJwt(jwt);
    const companyID = userService.getCompID();
    const companyRegisterRequest = {
      companies: [
        {
          businessProfileID: userService.getBPID(),
          companyID: companyID,
          companyName: childDTO.BranchName,
          companyType:
            selectedType /*[ PRIMARY, BRANCH, WAREHOUSE, MANUFACTURER ] */,
          customObject: null,
          registrationNumber: childDTO.taxNumber,
          termsAndConditionAccepted: ischecked,
          taxNumber: childDTO.taxNumber,
          userID: null,
          userType: null,
        },
      ],
    };

    try {
      const response = await companyController.CompanyRegistration({
        companyRegisterRequest: companyRegisterRequest,
        Authorization: jwt,
      });
      if (Utils.isSuccessResponse(response)) {
        // if (true) {
        const addCompanyAddressRequest = {
          address: {
            // addressID: null,
            country: childDTO.country,
            customeLable: "friends house",
            defaultAddress: true,
            label: "DEFAULT",
            locality: childDTO.City,
            postalCode: childDTO.taxNumber,
            pinnedAddress: childDTO.googleLocation,
            postalCodeSuffix: childDTO.taxNumber,
            route: childDTO.Street,
            streetNumber: childDTO.CompAddress,
            // userAddressID: "121213-cv221312-23e22",
          },
          companyID: companyID,
        };
        const AddAddress = await companyController.addCompanyAddress({
          addCompanyAddressRequest: addCompanyAddressRequest,
          Authorization: jwt,
        });
        if (Utils.isSuccessResponse(AddAddress) && AddAddress.data === true) {
          toast.success("Registered successfully!");
          setSubmitted(true);
        } else {
          toast.error(AddAddress.data.massage, "scas");
        }
      }
    } catch (err) {
      console.error("Company registration failed", err);
    }
    // setSubmitted(true);
  };
  return (
    <div>
      <div className="create-branch-page-header">
        <BusinessHubHeader />
      </div>

      <div className="create-branch-content-main-container">
        {submitted && (
          <div className="add-branch-popup-container">
            <div
              className="edit-role-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-role-popup-content">
                <div className="edit-role-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-role-successfully-added-text">
                  Temporary Activation
                </div>
                <div className="comp-reg-data-review-note">
                  Since you’re already an approved partner, your branch /
                  warehouse is active for now. <br />
                  <b>
                    Please upload the required documents within 2 months to
                    complete verification.
                  </b>
                </div>
                <div
                  className="uploud-branch-required-data"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Skip for now
                </div>
                <div
                  className="edit-role-successfully-added-action-button"
                  onClick={() => navigate("/related-comp-data")}
                >
                  Proceed
                </div>
              </div>
            </div>
          </div>
        )}

        {termsPop && (
          <div className="branch-create-popup-container">
            <div
              className="branch-create-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="branch-create-popup-content">
                <div className="branch-create-successfully-added-text">
                  Terms and Conditions
                </div>
                <div className="branch-create-successfully-added-icon">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Duis autem vel eum iriure
                  dolor in hendrerit in vulputate velit esse molestie consequat,
                  vel illum dolore eu feugiat nulla facilisis at vero eros et
                  accumsan et iusto odio dignissim qui blandit praesent luptatum
                  zzril delenit augue duis dolore te feugait nulla facilisi.
                  Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
                  consectetuer adipiscing elit, sed diam nonummy nibh euismod
                  tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut
                  wisi enim ad minim veniam, quis nostrud exerci tation
                  ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                  consequat.
                </div>
                {/* <div className="branch-reg-info-input-body-doc-agree">
                  <input
                    type="checkbox"
                    checked={ischecked}
                    onChange={(e) => setIschecked(e.target.checked)}
                  />
                  <div>I agree with the terms and conditions</div>
                </div> */}
                <div
                  className="branch-create-successfully-added-action-button"
                  // style={{
                  //   opacity: ischecked ? 1 : 0.5,
                  //   pointerEvents: ischecked ? "auto" : "none",
                  //   cursor: ischecked ? "pointer" : "not-allowed",
                  // }}
                  onClick={() => {
                    setTermsPop(false);
                    setIschecked(true);
                  }}
                >
                  Accept
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Main Form */}
        <div className="create-branch-content-container">
          <div className="create-branch-data-header">
            <div className="create-branch-header-navigation">
              <div
                className="create-branch-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", { state: { active: "A" } })
                }
              >
                <BackArrow />
              </div>
              <div className="create-branch-header-navigation-text">
                Back to Business Overview
              </div>
            </div>

            <div className="create-branch-header-text">
              <div className="create-branch-header-title">
                Add {selectedType}
              </div>
              <div className="create-branch-header-text-note">
                Fill in all required fields.
              </div>
            </div>
          </div>
          <div className="create-branch-body">
            <div className="branch-reg-window-container">
              <RelatedBInput
                onDataChange={setChildDTO}
                selectedType={selectedType}
              />
              <div className="comp-reg-info-input-body-doc-agree">
                <input
                  style={{ cursor: "pointer" }}
                  type="checkbox"
                  checked={ischecked}
                  onChange={(e) => setIschecked(e.target.checked)}
                />
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setTermsPop(true)}
                >
                  I agree with the terms and conditions
                </div>
              </div>
              <div className="branch-reg-info-input-footer">
                {/* {!termsPop && ( */}
                <div
                  className="branch-reg-submit-action-button"
                  onClick={handleSubmit}
                  style={{
                    opacity: ischecked ? 1 : 0.5,
                    pointerEvents: ischecked ? "auto" : "none",
                    cursor: ischecked ? "pointer" : "not-allowed",
                  }}
                >
                  Submit
                </div>
                {/* )} */}

                <div
                  className="branch-reg-cancel-action-button"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddBranch;
